export default {"src":"/_next/static/media/menu.8c61869d.svg","height":24,"width":25};